export default __webpack_public_path__ + "static/media/2.49ac27cf.jpg";